import React from "react";

// STYLES
import "./ForgotPasswordUpdateVersion.scss";

// COMPONENTS
import GenericButton from "../../ui/buttons/GenericButtons/GenericButton";
import { useResizeDetector } from "react-resize-detector";

interface IForgotPasswordUpdateVersionProps {
    onReturnToSignIn: () => void;
}

const ForgotPasswordUpdateVersion: React.FC<
    IForgotPasswordUpdateVersionProps
> = ({ onReturnToSignIn }) => {
    const handleContactSupport = () => {
        window.location.href =
            "mailto:support@instantheartrate.com?subject=Trouble%20Signing%20Into%20Web%20App";
    };

    const { width, ref } = useResizeDetector();

    return (
        <div className="ForgotPasswordUpdateVersion" ref={ref}>
            <div className="ForgotPasswordUpdateVersion__Wrapper">
                <h1>Oops!</h1>
                <p className="ForgotPasswordUpdateVersion__NoMargin">
                    Looks like your Instant Heart Rate app is out of date.
                    Update your app now to v7 or later to access all of the
                    latest and greatest features. Then return to sign in.
                </p>

                {width && width >= 650 ? (
                    <></>
                ) : (
                    <GenericButton
                        text="Update Instant Heart Rate"
                        onClick={() =>
                            window.open(
                                "https://apps.apple.com/us/app/instant-heart-rate-hr-monitor/id409625068",
                                "_blank", // NOTE: "_self" if can be used to use the same-tab
                            )
                        }
                    />
                )}
                <GenericButton
                    className="ForgotPasswordUpdateVersion__HollowButton"
                    text="Return to Sign In"
                    onClick={() => {
                        onReturnToSignIn();
                    }}
                />
                <p className="ForgotPasswordUpdateVersion__NoMargin">
                    If the problem persists, please contact our support team and
                    a human will be happy to help.
                </p>
                <GenericButton
                    className="ForgotPasswordUpdateVersion__HollowButton"
                    text="Contact Support"
                    onClick={() => {
                        handleContactSupport();
                    }}
                />
                <p className="ForgotPasswordUpdateVersion__MinorText">
                    Coming soon to Android!
                </p>
            </div>
        </div>
    );
};

export default ForgotPasswordUpdateVersion;
